import { Box, Grid, Typography,  Snackbar,
  Alert, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../reusableComponents/components/generics/TextInput";
import Checkbox from "@mui/material/Checkbox";
import { Form, Field } from "react-final-form";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import {
  fetchPolicyHolderInfo,
  loadingUser,
  login,
  loginCnss,
  refreshAuthToken,
} from "../action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  FORGOT_PASSWORD,
  HOME_PAGE,
  POLICY_HOLDER,
  PORTAL_INSUREE,
} from "../utils/constant";
import { decodeId } from "../utils/helper";
import ReCAPTCHA from "react-google-recaptcha";

const Content = styled(Typography)({
  color: "#00913E",
});
const GridPadding = styled(Grid)({
  marginTop: "2rem",
});
const CheckBoxStyle = styled(Grid)({
  marginTop: "2rem",
});

function SignInForm() {
  // const [loginToken, setLoginToken] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [recaptchaKey, setRecaptchaKey] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const formRef = useRef(null);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const captchaRef = useRef(null);
  
  const handleResetCaptcha = () => {
    if (captchaRef.current) {
      captchaRef.current.reset();
    }
  };

  const handleCaptchaChange = (value) => {
    // This function is called whenever the ReCAPTCHA value changes (e.g., when the user completes it)
    if (value) {
      setIsCaptchaVerified(true);
    } else {
      setIsCaptchaVerified(false);
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const SignInSuccess = useSelector((state) => state);
  const loginData = useSelector(
    (state) => state?.profileReducer?.loginResponseData
  );

  const loginError = useSelector((state) => state?.profileReducer?.errorLogin);
  let token;

  const captchaLanguage = i18n.language.split("-")[0];

  useEffect(() => {
    loginCnss();
    if (loginData) {
      localStorage.setItem("token", loginData);
    }
    if (loginData) {
      localStorage.setItem(
        "userData",
        SignInSuccess?.profileReducer?.loginResponseUserData?.payload?.username
      );
    }
    if (loginData) {
      token = localStorage.getItem("token");
      if (token) {
        dispatch(loadingUser(token));
        navigate(HOME_PAGE);
      }
    }
  }, [loginData, token]);

  useEffect(() => {
    console.log("====> callback", SignInSuccess?.profileReducer)
    if (SignInSuccess?.profileReducer?.currentUserResponseData) {
      // dispatch(
      //   fetchPolicyHolderInfo(
      //     SignInSuccess?.profileReducer?.currentUserResponseData?.id
      //   )
      // );
      if (!!SignInSuccess?.fosaReducer?.fosaUserData?.[0]?.iUser?.isFosaEmp) {
        navigate(HOME_PAGE);
      }
      if (
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
          ?.policyHolder.id
      ) {
        localStorage.setItem(
          "policyholderId",
          decodeId(
            SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
              ?.policyHolder.id
          )
        );
        if (
          SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
            ?.policyHolder.formPhPortal == false
        ) {
          navigate(HOME_PAGE);
        } else {
          if (
            SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
              ?.policyHolder.isApproved == false
          ) {
            navigate(POLICY_HOLDER);
          } else {
            navigate(HOME_PAGE);
          }
        }
      }
    }
  }, [
    SignInSuccess?.fosaReducer?.fosaUserData?.[0]?.iUser,
    SignInSuccess?.profileReducer?.currentUserResponseData,
    SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
      ?.policyHolder,
    loginData,
  ]);

  useEffect(() => {
    const storedUsername = localStorage.getItem("userName");
    const storedPassword = localStorage.getItem("password");
    if (storedUsername && storedPassword) {
      formRef.current.change("userName", storedUsername);
      formRef.current.change("password", storedPassword);
      setChecked(true)
    }
  }, []);
  useEffect(() => {
    console.log("useEffect");
    setRecaptchaKey((prevKey) => prevKey + 1);
    handleResetCaptcha();
  }, [i18n.language]);

  const handleRemeberMe = () => {
    setChecked(!checked);
  };

  const onSubmit = async (values, event) => {
    // event.preventDefault();
    if (checked) {
      localStorage.setItem("userName", values?.userName);
      localStorage.setItem("password", values?.password);
    } else {
      localStorage.removeItem("userName");
      localStorage.removeItem("password");
    }
    const respone = await dispatch(login(values));
  };

  const validate = (values) => {
    const errors = {};
    if (!values.userName) {
      errors.userName = t("UserName is required");
    }
    if (!values.password) {
      errors.password = t("Password is required");
    }
    return errors;
  };

  const forgotPasswordHandler = () => {
    navigate(FORGOT_PASSWORD);
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  return (
    <Grid item xs={12} className="sign-in-input">
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {t("login")}
      </Typography>
      <Grid container>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
            errors,
          }) => {
            formRef.current = form;
            return (
              <Grid item xs={12}>
                <form 
                  onSubmit={handleSubmit} 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit(e);
                    }
                  }}
                >
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="userName"
                        component={TextInput}
                        label={t("User Name")}
                        type="text"
                        required={true}
                        error={errors.userName}
                        placeholder={t("Please Enter UserName")}
                      />
                    </GridPadding>
                  </Grid>
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="password"
                        component={TextInput}
                        label={t("Password")}
                        // type={showPassword ? "text" : "password"}
                        required={true}
                        error={errors.password}
                        placeholder={t("Please Enter Your Password")}
                        // showPassword={showPassword}
                        // handleMouseDownPassword={handleMouseDownPassword}
                        // handleClickShowPassword={handleClickShowPassword}
                        password={"password"}
                      />
                    </GridPadding>
                  </Grid>
                  <Grid item xs={12} className="common-input">
                    <GridPadding>
                      <ReCAPTCHA
                        key={recaptchaKey}
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        ref={captchaRef}
                        onChange={handleCaptchaChange}
                        hl={captchaLanguage}
                      />
                    </GridPadding>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    marginTop={"1rem"}
                    marginBottom={"1rem"}
                  >
                    <Grid item display={"flex"} alignItems={"center"}>
                      <Checkbox
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 35 },
                        }}
                        onClick={() => handleRemeberMe()}
                        checked={checked}
                      />
                      <Typography color="#666666" style={{ cursor: "pointer" }}>
                        {t("Remember Me")}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Content>
                        <Typography
                          color="#666666"
                          onClick={forgotPasswordHandler}
                          // fontWeight="500"
                          // fontSize={"1.063rem"}
                          // lineHeight={"1.059rem"}
                          style={{ cursor: "pointer" }}
                        >
                          {t("Forgot Password?")}
                        </Typography>
                      </Content>
                    </Grid>
                  </Grid>
                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={
                      submitting || pristine || Object.keys(errors).length > 0 
                    }
                  >
                    {t("login")}
                  </Button>
                </form>
              </Grid>
            );
          }}
        />
        {loginError ? (
          <Typography
            color="red"
            fontSize={"1rem"}
            margin={"0 auto"}
            marginTop={"1rem"}
          >
            {t("Please Enter Valid Credential !")}
          </Typography>
        ) : (
          ""
        )}
                <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert onClose={handleSnackbarClose} severity="warning">
            {t(" Your session has expired.")}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
}

export default SignInForm;
